<template>
  <div class="text-center">
    

    <v-snackbar
      v-model="snackbar"
      :timeout="tiempo"
      :color="color"
      absolute
      top
      right
    >
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: ["text", "tiempo", "color"],
  data(){
    return{
      snackbar: true,
    }
  }
}
</script>